<script>
  import {
    Credits,
    Related,
    Share,
    Footer,
  } from '@st-graphics/graphics-components';
  import { copyJson } from '$lib/stores/st-lf.svelte';
</script>

<footer class="st-article-foot article-foot">
  <Share meta={copyJson.data?.meta} title={copyJson.data?.title} />

  <Credits {...copyJson.data?.credits} />

  {#if copyJson.data?.relatedarticles}
    <Related {...copyJson.data?.relatedarticles} />
  {/if}

  <Footer />
</footer>

<style lang="scss">
  .st-article-foot {
    padding-top: 20px;
    color: var(--st-black);
  }

  :global {
    .st-article-foot .share ul.share-list {
      display: flex;
      gap: 0.25rem;

      button {
        background-color: transparent;
        border: none;
      }

      .share-icon {
        width: 34px;
        height: 34px;
        text-align: center;

        &:before {
          z-index: 0;
        }
      }
    }

    .article-foot .credits ul {
      display: inline;
      font-family: var(--font-sans-serif);
      font-size: 0.8125rem;
      color: var(--credit-color);
    }

    .article-foot aside.related {
      max-width: 76.25rem;

      h2 {
        font-size: 1.7rem;
        font-family: var(--font-serif);
        color: var(--st-black);
        margin: 0;
        margin-bottom: 0.625rem;
      }

      p {
        font-family: var(--font-serif);
        font-size: 1.1rem;
        margin: 0;
        color: var(--st-black);
        line-height: 1.2;

        &.description a {
          color: var(--st-links);

          &:hover {
            text-decoration: underline;
            text-decoration-color: var(--st-links);
            text-decoration-style: dotted;
            text-decoration-thickness: 1px;
          }
        }
      }

      a {
        font-family: var(--font-serif);
        font-size: 1.1rem;
        text-decoration: none;
        margin: 0;

        h3 {
          color: var(--st-black);
          font-size: inherit;
          font-weight: inherit;
          font-family: inherit;
          margin: 0;
        }

        figure {
          margin: 0;
          margin-bottom: 0.625rem;
          img {
            margin: 0;
          }
        }
      }

      ul.list {
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        column-gap: 1.25rem;
        row-gap: 1.25rem;
        padding-bottom: 1.2rem;
        margin-top: 1.2rem;

        @media (min-width: 428px) {
          grid-template-columns: repeat(2, 1fr);
        }

        @media (min-width: 744px) {
          grid-template-columns: repeat(3, 1fr);
        }

        @media (min-width: 1200px) {
          grid-template-columns: repeat(4, 1fr);
        }
      }
    }
  }
</style>
